
    export enum EnumCompanyStatus {
			Certified = 0,
			Pending = 1,
			NonOU = 2,
			Withdrawn = 3,
			Terminated = 4,
			Unauthorized = 5,
			NotApplicable = 6,
			Special = 7,
			Rejected = 8,
			Inactive = 9,
			Review = 10,
    }